@if (componentData.data$ | async; as component) {
  <div class="container">
    <div class="row">
      <boels-media
        class="banner"
        [container]="component.media"
        [alt]="component.imageAltText"
        [loading]="ImageLoadingStrategy.LAZY"
        [sizes]="
          '(min-width: 576px) 510px, ' +
          '(min-width: 768px) 690px, ' +
          '(min-width: 992px) 930px, ' +
          '330px'
        "
      ></boels-media>
    </div>
  </div>
}
